import { makeAutoObservable } from "mobx";

export default class EventFiltersStore {
  query = undefined;
  selectedSeverities = new Set();
  time;

  constructor({ query, selectedSeverities, time }) {
    this.query = query;
    this.time = time;
    this.selectedSeverities = new Set([...selectedSeverities]);
    makeAutoObservable(this);
  }

  toggleSeverity({ severity }) {
    if (this.selectedSeverities.has(severity))
      this.selectedSeverities.delete(severity);
    else this.selectedSeverities.add(severity);
  }
}
